<template>
  <main v-loading="loading"
    class="not-for-print main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <!-- nav -->

    <div class="area">
      <ul class="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
        <router-view @set-loading="setLoading" />
        <app-footer v-show="showFooter" />
    </div>
  </main>

</template>

<script> 
import AppFooter from "@/examples/Footer.vue";
import { mapState } from "vuex"; 
import CryptoJS from "crypto-js";
import * as SignalR from "@aspnet/signalr";
import { signalapi } from "./project/Source/helper.js";
import "bootstrap-icons/font/bootstrap-icons.css";

function formatNumber(num) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(num);
}

export default {
  name: "App",
  components: { 
    AppFooter
  },
  computed: {
    ...mapState([
      "isTransparent",
      "isRTL",
      "isPinned",
      "isNavFixed",
      "isAbsolute",
      "navbarFixed",
      "absolute",
      "color",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
    ]),
    vatSum() {
      return this.clinicAktInfo.vatSum != 0
        ? `${formatNumber(this.clinicAktInfo.vatSum)} manat (${this.clinicAktInfo.vatSumStr
        })` +
        (this.clinicAktInfo.vatNfc
          ? ` ƏDV tətbiq olunan məbləğ: ${formatNumber(
            this.clinicAktInfo.vatSum / (1.0 - 1.0 / 1.18)
          )}`
          : "")
        : "      ---";
    },
    dateStamp() {
      let actDate = this.clinicAktInfo.actDate;

      let validDate = actDate ? new Date(actDate) : new Date("2000-01-01");

      if (validDate >= new Date("2023-10-01")) {
        return true;
      } else {
        return false;
      }
    },
    signName() {
      let value = false;

      if (this.clinicAktInfo.signerName === "Rəna Daneşvar") {
        value = "@/assets/img/logos/AktAtes/signRena.png";
      } else {
        value = "@/assets/img/logos/AktAtes/signNigar.png";
      }

      return value;
    },
  },
  data() {
    return {
      bindNavbar: true,
      logoMain: null,
      loading: false,
      eksperText: null,
      sideVis: true,
      clinicAktInfo: null,
      clinicReyesVis: false,
      clinicAktVis: false,
      clinicInfo: {
        sumInsured: null,
        caught: null,
        registerId: null,
        editSumInsured: null,
        status: null,
        saveTitle: null,
        expertiseSumInsured: null,
      },
      retentionSumSum: null,
      clinicTable: null,
      connection: new SignalR.HubConnectionBuilder().withUrl(signalapi).build(),
    };
  },
  methods: {
    setLoading() {
      this.loading = true;
    },
    company() {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).companyName;
    },
  },
};
</script>

<style>
main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
}

</style>
